import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { boardState, BoardStatus } from 'common/modules/app/board';
import { GlossaryState } from 'common/modules/app/glossaries';
import { FetchState, FetchStatus } from 'common/modules/app/fetch';
import {
  UserInformation,
  getLogout,
  LOGOUT_USER
} from 'common/modules/domain/user';
import { Glossary } from 'common/utils/glossary';
import { SasCookieKeys, loadCookie } from 'common/utils/cookie-utils';
import { AppState } from 'pages';
import { UserBoard } from '../components/UserBoard';
import { canonIdProfileUrl } from 'common/utils/urls';

/**
 * StoreのStateからComponentに渡すPropsへ
 */
const useStateProps = () => {
  const boardState = useSelector<AppState, boardState>(
    (state) => state.app.board
  );
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );
  const userState = useSelector<AppState, UserInformation>(
    (state) => state.domain.user
  );
  const fetchState = useSelector<AppState, FetchState>(
    (state) => state.app.fetch
  );

  return {
    isDisplay: boardState.status === BoardStatus.USER_DISP,
    glossary: Glossary.instance(glState),
    mailAddress: userState.email,
    logoutProcess: fetchState[LOGOUT_USER]
  };
};

type SelectedState = ReturnType<typeof useStateProps>;

// Actionをdispatchする関数からComponentに渡すPropsへ
const useDispatchProps = (state: SelectedState) => {
  const dispatch = useDispatch();
  /** プロフィールの編集の押下処理 */
  const onClickProfile = () => {
    // プロフィールの編集のURLへ遷移
    window.location.href = canonIdProfileUrl;
  };

  /** ログアウトの押下処理 */
  const onClickLogout = () => {
    // ログアウト実施中の場合は何もしない
    if (state.logoutProcess !== FetchStatus.PROCESSING) {
      const cookie = loadCookie();
      dispatch(getLogout(cookie[SasCookieKeys.KEY_TOKEN]));
    }
  };
  return {
    onClickProfile: onClickProfile,
    onClickLogout: onClickLogout
  };
};

/**
 * メニュー画面全体のContainer Component
 */
export default function ContainerComponent() {
  const _props = { ...useStateProps(), ...useDispatchProps(useStateProps()) };
  return <UserBoard {..._props} />;
}
